// extracted by mini-css-extract-plugin
var _1 = "ra-artist-cv";
var _2 = "ra-artist-cv-print";
var _3 = "ra-artist-cv-print-header";
var _4 = "ra-artist-cv-print-link";
export { _1 as "artistCvCls", _2 as "artistCvPrintCls", _3 as "artistCvPrintHeaderCls", _4 as "artistCvPrintLinkCls" }
